import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

//Modules
import UserModule from "./user";
import StoryModule from "./story";
import ManagerModule from "./manager";
import Billboard from "./billboard";
import EduResource from "./edu-resource";
import School from "./school";
import Notification from "./notification";

export default new Vuex.Store({
	modules: {
		user: UserModule,
		story: StoryModule,
		manager: ManagerModule,
		billboard: Billboard,
		resource: EduResource,
		school: School,
		notification: Notification
	},
	state: {},
	getters: {},
	mutations: {},
	actions: {
		async logout({ dispatch, commit }) {
			let $bus = new Vue().$bus;
			await dispatch("user/cleanToken");
			await commit("user/cleanUserInfo");
			await commit("story/cleanCreateStories");
			await commit("story/cleanEditStoryData");
			await commit("story/cleanStoryList");
			await commit("story/cleanPasswordStories");
			$bus.$emit("userLogout");
		},
		async managerLogout({ dispatch, commit }) {
			let $bus = new Vue().$bus;
			await dispatch("user/cleanToken");
			await commit("user/cleanUserInfo");
			await commit("story/cleanCreateStories");
			await commit("story/cleanEditStoryData");
			await commit("story/cleanStoryList");
			await commit("story/cleanPasswordStories");
			await commit("story/cleanStoryList");
			$bus.$emit("managerLogout");
		}
	}
});
